module.exports = __webpack_public_path__ + "media/images/alumni/content-bb3bd012cfe4368b8a9ff044539dfb83.jpg";